import { render, staticRenderFns } from "./ModuleEditorLayout.vue?vue&type=template&id=b8c03b96&scoped=true"
import script from "./ModuleEditorLayout.vue?vue&type=script&lang=js"
export * from "./ModuleEditorLayout.vue?vue&type=script&lang=js"
import style0 from "./ModuleEditorLayout.vue?vue&type=style&index=0&id=b8c03b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c03b96",
  null
  
)

export default component.exports